/*
 * Variant Image Filter for Dawn 15.4.1
 * Filters product gallery images by variant using #tag suffixes in alt text.
 *
 * How it works:
 * - Images with no #tag in their alt text are "shared" and always visible.
 * - Images with a #tag (e.g. "...alt text here #Baby Ben 42") only show
 *   when the selected variant's option value matches the tag.
 * - On variant change, non-matching images are hidden and the slider
 *   recalculates its pages automatically.
 *
 * Upload this file to your theme's Assets folder, then add the following
 * line to theme.liquid just before </body>:
 *   <script src="{{ 'variant-image-filter.js' | asset_url }}" defer="defer"></script>
 */
(function () {
  function filterVariantMedia(variant) {
    if (!variant) return;

    var options = variant.options || [];
    if (!options.length && variant.title) {
      options = variant.title.split(' / ');
    }

    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var items = gallery.querySelectorAll('[data-variant-group]');
      var hasAnyTags = false;

      items.forEach(function (item) {
        if (item.getAttribute('data-variant-group') !== 'shared') {
          hasAnyTags = true;
        }
      });

      // If no images use tags on this product, skip filtering entirely
      if (!hasAnyTags) return;

      items.forEach(function (item) {
        var group = item.getAttribute('data-variant-group');
        if (group === 'shared' || options.indexOf(group) !== -1) {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      });

      // Let the browser reflow, then recalculate slider pages and counter
      requestAnimationFrame(function () {
        var viewer = gallery.querySelector('[id^="GalleryViewer"]');
        if (viewer && viewer.resetPages) viewer.resetPages();

        var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
        if (thumbs && thumbs.resetPages) thumbs.resetPages();
      });
    });
  }

  // Hook into Dawn's pub/sub system for variant changes
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      filterVariantMedia(event.data.variant);
    });
  }
})();
